import React, { useRef, useState } from 'react';
import clsx from 'clsx';
import Calendar from 'components/calendar';
import CalendarDrawer from 'components/calendar/drawer';
import { timeUtils } from 'utils/timeUtil';
import style from './style.module.scss';
import SoundPromptSettings from 'components/soundPromptSettings';

const BasketballContainer = ({
  children,
  onChangePage,
  count,
  selectedTab,
  setSelectedTab
}) => {
  const calendarOpenButtonRef = useRef();
  const [today] = useState(timeUtils.todayYmd());
  const [isOpenTip, setOpenTip] = useState(false);
  const [isOpenWebCalendar, setIsOpenWebCalendar] = useState(false);
  const [currentDate, setCurrentDate] = useState(today);

  const onClickToday = () => {
    setCurrentDate(today);
    onChangePage(today);
    setSelectedTab('ALL');
  };

  const onClickPrev = () => {
    const prev = timeUtils.datePrevOrNext(currentDate, 'prev');
    setCurrentDate(prev);
    onChangePage(prev);
    setSelectedTab('ALL');
  };

  const onClickNext = () => {
    const next = timeUtils.datePrevOrNext(currentDate, 'next');
    setCurrentDate(next);
    onChangePage(next);
    setSelectedTab('ALL');
  };

  const onClickTab = (type) => {
    let label = '전체';

    if (type === 'ALL') {
      label = '전체';
    } else if (type === 'READY') {
      label = '대기중';
    } else if (type === 'PROGRESS') {
      label = '진행중';
    } else if (type === 'FINAL') {
      label = '종료';
    }

    setSelectedTab(type);
  };

  const onClickCalendarButton = () => {
    setIsOpenWebCalendar(!isOpenWebCalendar);
  };

  const onClickRefresh = () => {
    onChangePage(currentDate);
  };

  const onClickTip = () => {
    setOpenTip(!isOpenTip);
  };

  const onChangeCalendarPage = (date) => {
    onChangePage(date);
  };

  return (
    <>
      <div className={style.option_wrap}>
        <div className={style.calendar_area}>
          <button
            className={clsx(style.btn_ic, style.btn_prev)}
            onClick={onClickPrev}
          >
            이전
          </button>
          <span className={style.date}>{currentDate.split('-').join('.')}</span>
          <button
            className={clsx(style.btn_ic, style.btn_next)}
            onClick={onClickNext}
          >
            다음
          </button>
          <button
            ref={calendarOpenButtonRef}
            className={clsx(style.btn_bx, style.btn_calendar)}
            onClick={onClickCalendarButton}
          >
            달력
          </button>
          <button
            className={clsx(style.btn_bx, style.btn_today)}
            onClick={onClickToday}
          >
            오늘
          </button>
        </div>
        <div className={style.option_btn_area}>
          {/* <a className={style.btn btn_full" href="">전체모드</a>
      <a className={style.btn btn_small" href="">축소모드</a>
      <a className={style.btn btn_setup" href="">설정</a> */}
          <SoundPromptSettings sportsType="basketball" />
          <button
            className={clsx(style.btn, style.btn_refresh)}
            onClick={onClickRefresh}
          >
            새로고침
          </button>
        </div>
        <div className={style.category_area}>
          <ul className={style.tab}>
            <li className={clsx(selectedTab === 'ALL' && style.selected)}>
              <button onClick={() => onClickTab('ALL')}>
                전체({count.all})
              </button>
            </li>
            <li className={clsx(selectedTab === 'READY' && style.selected)}>
              <button onClick={() => onClickTab('READY')}>
                대기중({count.ready})
              </button>
            </li>
            <li className={clsx(selectedTab === 'PROGRESS' && style.selected)}>
              <button onClick={() => onClickTab('PROGRESS')}>
                진행중({count.inProgress})
              </button>
            </li>
            <li className={clsx(selectedTab === 'FINAL' && style.selected)}>
              <button onClick={() => onClickTab('FINAL')}>
                종료({count.final})
              </button>
            </li>
          </ul>
          <div className={style.tip_area}>
            <button className={style.btn_tip} onClick={onClickTip}>
              스페셜정보 안내
            </button>
            <SportsOptionTips open={isOpenTip} toggleOpen={onClickTip} />
          </div>
        </div>

        <CalendarDrawer
          transitionClass="web-calendar-transition"
          isOpen={isOpenWebCalendar}
          closeDrawer={() => setIsOpenWebCalendar(false)}
        >
          <Calendar
            onClickToday={onClickToday}
            currentDate={currentDate}
            onChangePage={onChangeCalendarPage}
            setCurrentDate={setCurrentDate}
            sportsType={'basketball'}
            closeDrawer={() => setIsOpenWebCalendar(false)}
            calendarOpenButtonRef={calendarOpenButtonRef}
          />
        </CalendarDrawer>
      </div>
      {children}
    </>
  );
};

const SportsOptionTips = ({ open, toggleOpen }) => {
  if (open) {
    return (
      <div className={style.tip_layer}>
        <ul className={style.cont}>
          <li className={style.s_first}>첫득점</li>
          <li className={style.s_three}>첫3점슛</li>
          <li className={style.s_free}>첫자유투</li>
          <li className={style.s_5}>선5점</li>
          <li className={style.s_7}>선7점</li>
          <li className={style.s_10}>선10점</li>
        </ul>
        <button className={style.btn_close} onClick={toggleOpen}>
          닫기
        </button>
      </div>
    );
  } else {
    return null;
  }
};

export default BasketballContainer;
